import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";
const lucidIcons = require("lucide-static");

export default class CategoriesController extends Controller {
  static targets = ["input"];
  static values = {
    icon: String,
  };

  connect() {
    if (!this.listIcons) {
      this.listIcons = Object.keys(lucidIcons)
        .slice(3, Object.keys(lucidIcons).length)
        .map((key) => {
          const kebabKey = this.toKebabCase(key);
          return {
            text: key,
            value: kebabKey,
          };
        });
    }

    const elementOptions = JSON.parse(
      this.inputTarget.dataset?.slimOptions || "{}"
    );

    this.tomSelect = new TomSelect(this.inputTarget, {
      created: true,
      options: this.listIcons,
      render: {
        option: (item, escape) => {
          return `<div class="flex items-center"> ${
            lucidIcons[item.text]
          } - ${escape(item.text)} </div>`;
        },
        ...elementOptions,
      },
    });

    if (this.iconValue) {
      this.tomSelect.setValue(this.iconValue);
    }
  }

  toKebabCase(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  }
}
